

// export default CounsellorChatCard
import React from 'react';
import polygon3 from 'assets/images/Polygon3.png';
import { showModal } from 'store/reducers/modal';
import Counsellorform from 'components/counsellorapointment/counsellorform';
import { useDispatch } from 'react-redux';

const CounsellorChatCard = () => {
  const dispatch = useDispatch();

  const CounsellorSubmit = () => {
    return (
      <div className="flex flex-col z-10 items-start gap-7 w-full rounded-lg">
        <div className="flex w-full md:h-20 h-12 bg-white rounded-lg">
          <input
            placeholder='Enter Your Email'
            className="w-3/5 h-full outline-none font-manrope py-2 px-10 border-none rounded-l-lg"
          />
          <div
            className="flex h-full w-2/5 cursor-pointer justify-center items-center bg-yellow-400 rounded-r-lg"
            onClick={() => dispatch(showModal({ content: <Counsellorform /> }))}
          >
          <h2 className='text-secondary md:text-[20px]'  >Schedule Now</h2>
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className="md:px-24 py-12 px-6">
      <div className="relative flex flex-col items-center bg-[#00296B] rounded-2xl md:p-20 p-12 gap-14 md:max-w-4xl mx-auto ">
        <img
          className="absolute -left-[1px] -top-[2px]"
          src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1718279668/ERC/Polygon4_tbbbbp.svg"
          alt="Left Decoration"
        />
        <img
          className="absolute -right-[1px] -bottom-[2px]"
          src={polygon3}
          alt="Right Decoration"
        />
        <div className="flex flex-col items-center gap-5 z-10">
           <h2 className='md:text-[40px] font-ManropeSemibold text-[24px] md:leading-[48px] text-white'>Chat With a Counsellor</h2>
         <p className='text-white md:text-[20px] leading-6 text-center font-ManropeLight '> Embrace the courage to seek guidance, for within vulnerability lies strength</p>
        </div>
        <div className="md:mt-14 w-full flex justify-center items-center px-6">
          <CounsellorSubmit />
        </div>
      </div>
    </div>
  );
};

export default CounsellorChatCard;
